import { render, staticRenderFns } from "./yaerProductSales.vue?vue&type=template&id=51c125fc&scoped=true&"
import script from "./yaerProductSales.vue?vue&type=script&lang=js&"
export * from "./yaerProductSales.vue?vue&type=script&lang=js&"
import style0 from "./yaerProductSales.vue?vue&type=style&index=0&id=51c125fc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c125fc",
  null
  
)

export default component.exports